(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
class complementarySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 15,
      freeMode: true,
      mousewheel: {
        forceToAxis: true
      },
    });

    const items = this.querySelectorAll(".swiper-slide");

    // 🔹 Handle swiper-slide clicks
    items.forEach(item => {
      item.addEventListener("click", () => {
        const upsellId = item.getAttribute("data-upsell-id");

        // Update upsell-filters
        if (upsellId) {
          const targetFilter = document.querySelector(`.upsell-filters#${upsellId}`);
          if (targetFilter) {
            document.querySelectorAll(".upsell-filters.active")
              .forEach(el => el.classList.remove("active"));
            targetFilter.classList.add("active");
            this.querySelector('[name="upsell-id"]').value = targetFilter.querySelector('.upsell-varitant-option button').dataset.variantId;
          }else{
            document.querySelectorAll(".upsell-filters.active")
              .forEach(el => el.classList.remove("active"));
            this.querySelector('[name="upsell-id"]').value = "";

          }
        }

        // Update swiper-slide active state
        items.forEach(el => el.classList.remove("upsell-active"));
        item.classList.add("upsell-active");
      });
    });

    // 🔹 Handle upsell-variant-option button clicks
    this.querySelectorAll(".upsell-varitant-option button").forEach(button => {
      button.addEventListener("click", (e) => {
        e.preventDefault;
        const parentFilter = button.closest(".upsell-filters");

        if (parentFilter && parentFilter.classList.contains("active")) {
          // Remove active from siblings
          parentFilter.querySelectorAll(".upsell-varitant-option button.active")
            .forEach(btn => btn.classList.remove("active"));

          // Add active to clicked button
          button.classList.add("active");
          this.querySelector('[name="upsell-id"]').value=button.dataset.variantId;
        }
      });
    });
  }
}

customElements.define("complementary-slider", complementarySlider);




  } catch(e) { console.error(e); }
})();
})();
